<template>
  <div class="network-container">
    <div class="title-desc">
      <h1>网络状态检测</h1>
      <p>基于navigator.connection方法和资源下载速度</p>
    </div>
    <div class="network-status">
      <NetworkInfo></NetworkInfo>
    </div>
  </div>
</template>

<script>
import NetworkInfo from "./NetworkInfo.vue";

export default {
  name: "NetworkStatus",
  metaInfo: {
    title: "网络测速", // 设置页面标题
    meta: [
      { name: "description", content: "大鸡排工作室出品！" }, // 设置页面描述
    ],
  },
  components: { NetworkInfo },
};
</script>

<style scoped>
.network-container {
  display: flex;
  flex-direction: column; /* 修改布局方向为垂直 */
  align-items: center; /* 垂直居中 */
  text-align: center; /* 将文本内容居中对齐 */
  justify-content: flex-start;
  min-height: calc(100vh - 160px);
}

.network-status {
  padding: 20px;
  width: 40%;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid orange;
  background-color: orange;
}
</style>


// WEBPACK FOOTER //
// src/components/NetworkStatus.vue